module.exports = __webpack_public_path__ + "img/collapse-btn-logo.3f174dc2.png";